import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-6">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-8"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Home
        </button>

        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Cookie Policy</h1>
          <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. What Are Cookies</h2>
              <p className="text-gray-700 leading-relaxed">
                Cookies are small text files that are placed on your device when you visit our PROBUILD MARKET platform. 
                They help us provide you with a better experience by remembering your preferences and 
                understanding how you use our services. This Cookie Policy is part of our Privacy Policy and 
                complies with the EU Cookie Directive and GDPR requirements.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Types of Cookies We Use</h2>
              
              <h3 className="text-xl font-medium text-gray-800 mb-3">2.1 Essential Cookies (Strictly Necessary)</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                These cookies are necessary for the website to function properly. They enable core 
                functionality such as security, network management, and accessibility. You cannot opt-out 
                of these cookies as they are essential for the platform to work.
              </p>

              <h3 className="text-xl font-medium text-gray-800 mb-3">2.2 Analytics Cookies</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                We use analytics cookies to understand how visitors interact with our website. This 
                helps us improve our services and user experience. These cookies collect anonymous 
                information about page visits, traffic sources, and user behavior patterns.
              </p>

              <h3 className="text-xl font-medium text-gray-800 mb-3">2.3 Functional Cookies</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                These cookies enable personalized features and remember your preferences such as 
                language selection, region, and display settings.
              </p>

              <h3 className="text-xl font-medium text-gray-800 mb-3">2.4 Marketing Cookies</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                With your consent, we may use marketing cookies to show you relevant advertisements 
                and track the effectiveness of our marketing campaigns.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. How We Use Cookies</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>To keep you signed in to your account</li>
                <li>To understand and analyze platform usage</li>
                <li>To remember your language and regional preferences</li>
                <li>To improve website performance and loading times</li>
                <li>To provide relevant content and features</li>
                <li>To measure the effectiveness of our services</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Third-Party Cookies</h2>
              <p className="text-gray-700 leading-relaxed">
                We may use third-party services that set cookies on your device. These services help us 
                analyze website traffic and improve our platform. We carefully select our partners and 
                ensure they comply with GDPR requirements.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Managing Cookies</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You have the right to decide whether to accept or reject cookies. You can control and 
                manage cookies in various ways:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Browser settings:</strong> Most browsers allow you to refuse or accept cookies through their settings</li>
                <li><strong>Cookie banner:</strong> You can manage your cookie preferences through our cookie consent banner</li>
                <li><strong>Clear cookies:</strong> You can delete cookies from your browser at any time</li>
                <li><strong>Opt-out tools:</strong> You can use opt-out tools provided by advertising networks</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                <strong>Please note:</strong> Disabling certain cookies may affect the functionality of our platform 
                and limit your access to some features.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Cookie Duration</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We use both session cookies (which expire when you close your browser) and persistent 
                cookies (which remain on your device for a set period or until you delete them).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Updates to This Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                We may update this Cookie Policy from time to time. Any changes will be posted on this 
                page with an updated revision date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                If you have questions about our use of cookies, please contact us at:
              </p>
              <div className="mt-4 p-6 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-gray-700 font-semibold mb-2">PROBUILD MARKET LIMITED</p>
                <p className="text-gray-700">THE BLACK CHURCH, ST. MARY'S PLACE</p>
                <p className="text-gray-700">DUBLIN 7, D07 P4AX</p>
                <p className="text-gray-700">IRELAND</p>
                <p className="text-gray-700 mt-3">Reg. Numb.: 796855</p>
                <p className="text-gray-700 mt-3">
                  Email: <a href="mailto:contact@probuildmarket.net" className="text-blue-600 hover:underline">contact@probuildmarket.net</a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;